import {Component, OnDestroy, AfterViewInit, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {User} from "../shared/interfaces";
import {AuthService} from "../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MaterialService} from "../shared/classes/material.service";
import {   NbThemeService } from '@nebular/theme';
import {NbToastrService, NbGlobalPosition } from '@nebular/theme';
  import { GoogleAnalyticsService } from '../@core/utils/analytics.service';


@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit, OnDestroy  {

  form: FormGroup
  aSub:Subscription
  messageSuccess: string  
  recaptchaResolved:boolean = false

  constructor(
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private themeService: NbThemeService,
    private toastrService: NbToastrService,
  public gAnalytics: GoogleAnalyticsService

  ) {
 
    if(this.authService.isAuthenticated()){
      this.router.navigate(['/overview'])
      return
    }
    
    this.themeService.changeTheme(localStorage.getItem('theme') || 'default')

  }


    ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      //recaptchaReactive: new FormControl(null, Validators.required)
    })

	

  } 

	resolvedRecaptcha(event){
		if(event === null){
			this.recaptchaResolved = false 
		}else{
			this.recaptchaResolved = true 
		}
		 
	}
	 

  ngOnDestroy(){
    if(this.aSub){
      this.aSub.unsubscribe()
    }
  }



  submit() {
    if(this.form.invalid){
      return
    }

    const user:User = this.form.value;

    this.form.disable()
    this.aSub = this.authService.registration(user).subscribe((data:any)=>{
	
	if(data?.sentEmail === true){
		this.messageSuccess = 'Ваш кабінет успішно створений!'

		 this.gAnalytics.trackEvent('Reg_mail_send')
		this.form.reset()
	}else{
		 this.toastrService.show('','Сталася помилка',{
		  status: 'danger',
		position: <NbGlobalPosition>'bottom-right'
		})
	 this.form.enable()
	}
	
      /*  this.router.navigate(['/login'],{
          queryParams: {
            registered: true
          }
        }) */
    }, error => {
      this.form.enable()
       this.toastrService.show('',error.error ? error.error.message : error.message,{
          status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
        })
    })

  }

}
